<!-- loading-overlay.html -->
<div *ngIf="show$ | async" class="overlay">
    <mat-spinner diameter="50"></mat-spinner>
</div>
